const getStorePhone = (storeInfoFromFeed, store) => {
  let storePhone = store.PhoneNumber || store.Phone || ''
  if (storeInfoFromFeed) {
    storePhone = storeInfoFromFeed.phone
  }
  return storePhone.replace('/', '-')
}

export default getStorePhone
